"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Camera = void 0;
const gl_matrix_1 = require("gl-matrix");
class Camera {
    static init(aspect) {
        return new Camera(aspect);
    }
    constructor(aspect) {
        this.projectionMatrix = gl_matrix_1.mat4.create();
        this.fov = gl_matrix_1.glMatrix.toRadian(60);
        this.near = 1.0;
        this.far = 8192.0;
        this.viewMatrix = gl_matrix_1.mat4.create();
        this.position = gl_matrix_1.vec3.create();
        this.rotation = gl_matrix_1.vec3.create();
        this.aspect = aspect;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        gl_matrix_1.mat4.perspective(this.projectionMatrix, this.fov, this.aspect, this.near, this.far);
    }
    updateViewMatrix() {
        gl_matrix_1.mat4.identity(this.viewMatrix);
        gl_matrix_1.mat4.rotateX(this.viewMatrix, this.viewMatrix, this.rotation[0] - Math.PI / 2);
        gl_matrix_1.mat4.rotateZ(this.viewMatrix, this.viewMatrix, Math.PI / 2 - this.rotation[1]);
        gl_matrix_1.mat4.translate(this.viewMatrix, this.viewMatrix, [
            -this.position[0],
            -this.position[1],
            -this.position[2]
        ]);
    }
}
exports.Camera = Camera;
